<template>
  <div class="page-main">
    <el-radio-group v-model="tabPosition" size="mini">
      <el-radio-button :label="item.val" v-for="(item, index) in btnList" :key="index">
        {{ item.key }}
      </el-radio-button>
    </el-radio-group>
    <component :is="`List${tabPosition}`" class="m-t-10" />
  </div>
</template>

<script>
import List1 from './list-1'
import List2 from './list-2'
import List3 from './list-3'
export default {
  components: {
    List1,
    List2,
    List3
  },
  data() {
    return {
      tabPosition: 1,
      btnList: [
        {
          key: '客户交易',
          val: 1
        },
        {
          key: '分布地区',
          val: 2
        },
        {
          key: '分布行业',
          val: 3
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
